<template>
  <section class="w-full pt-4 md:px-3"> 
    <form @submit.prevent="JSON.stringify(props.experiencetoUpdate) != '{}' 
            ? updateExperience() 
            : addNewExperience()" class="grid grid-cols-12 gap-4 text-base font-normal">
      <span class="col-span-12 md:col-span-6">
        <label class="required-sign">{{ translate('job title', 'ucfirst') }}</label>
        <CustomInputText name="exjob_title" class="w-full px-3 py-2 mt-2.5 rounded-full border border-iron" />
      </span>
      <span class="col-span-12 md:col-span-6">
        <label class="required-sign">{{ translate('company name', 'ucfirst') }}</label>
        <CustomInputText name="excompany_name" class="w-full px-3 py-2 mt-2.5 rounded-full border border-iron" />
      </span>
      <span class="col-span-12 md:col-span-12">
        <label class="required-sign">{{ translate('description', 'ucfirst') }}</label>
        <CustomTextArea name="exdescription" :max-field-char="3000" :placeholder="translate('describe your job experience', 'ucfirst')" class="w-full min-h-28 max-h-36 px-3 py-2 mt-2.5 rounded-md border border-iron" />
      </span>
      <span class="col-span-12 md:col-span-6">
        <label class="required-sign">{{ translate('start date', 'ucfirst') }}</label> 
        <CustomCalendarDate name="exstart_date" :maxDate="maxDate.start_date" :format="detectarFormatoDataLocal()" class="w-full px-3 py-2 mt-2.5 rounded-full border border-iron" />
      </span>
      
      <span class="col-span-12 md:col-span-6 mb-10"> 
        <label v-if="!exibirdateend">{{ translate('end date', 'ucfirst') }}</label>
        <CustomCalendarDate v-if="!exibirdateend"  name="exend_date" :maxDate="maxDate.end_date" :format="detectarFormatoDataLocal()" class="w-full px-3 py-2 mt-2.5 rounded-full border border-iron" />
        <input type="checkbox" id="present" v-model="isPresent" @change="checkpresent($event)" />
        <label for="present" class="ml-2">{{ translate('currently working', 'ucfirst') }}</label><br>
        </span>
      <div class="flex flex-wrap justify-evenly col-span-12">
        <Button
          v-if="Object.keys(props.experiencetoUpdate).length > 0"
          @click="showConfirmDialog = true"
          type="button"
          :label="translate('delete', 'ucfirst')"
          class="text-white px-10 py-2 float-left rounded-full bg-red-600"
        />
        <Button type="submit"
          :label="Object.keys(props.experiencetoUpdate).length > 0 
            ? translate('update', 'ucfirst') 
            : translate('save', 'ucfirst')" class="text-white px-10 py-2 ml-auto float-right rounded-full bg-sea-serpent" />
      </div>
    </form>

    <CustomConfirmDialog
      :show-confirm="showConfirmDialog" @confirmResponse="confirmDialogResponse"
    />
    <LoadingDialog :visible="isLoading" />
  </section>
</template>

<script setup>
import { ref, onBeforeMount, onMounted } from "vue" 
import Button from "primevue/button" 
import { useToast } from "primevue/usetoast";
import { showToast } from "@/composables/toast";
import { translate } from "@/composables/translate";
import requestHandler from "@/composables/requestHandler";
import LoadingDialog from "@/components/Utils/LoadingDialog.vue";
import CustomInputText from "@/components/Base/CustomInputText.vue";
import CustomTextArea from "@/components/Base/CustomTextArea.vue";
import CustomCalendarDate from "@/components/Base/CustomCalendarDate.vue";
import CustomConfirmDialog from "@/components/Utils/CustomConfirmDialog.vue";
import { useForm } from 'vee-validate';
import { toTypedSchema } from "@vee-validate/yup";
import{ object, string, date } from 'yup';


let toast = useToast();
let isLoading = ref(false)
let maxDate = ref({
  start_date: new Date(),
  end_date: new Date()
})
let showConfirmDialog = ref(false);

const props = defineProps({
    experiencetoUpdate: {
        type: Object,
        required: false,
        default: () => {}
    },
    curriculumId: {
      type: Number,
      required: false
    }
  });

const emit = defineEmits(['closeModal','updateExperiencies'])


const isPresent = ref(false);
let exibirdateend = ref(false)

function checkpresent(e) {
  if (e.target.checked) {
    setValues({ exend_date: undefined });
    exibirdateend.value = true
  } else {
    exibirdateend.value = false
  }
}

function detectarFormatoDataLocal(date = new Date(2000, 11, 31)) {
  const idioma = navigator.language || 'en-US';
  const data = date; // 31 de dezembro de 2000
  const formatada = data.toLocaleDateString(idioma);

  // Agora você vai transformar "31/12/2000" em "dd/mm/yyyy" ou similar
  const partes = formatada.match(/(\d+)/g);

  // Posição dos elementos
  const ordem = formatada.replace(/\d+/g, (match, index) => {
    console.log(index); 
    if (match === partes[0]) return 'dd';
    if (match === partes[1]) return 'mm';
    if (match === partes[2]) return 'yy';
  });

  // Resultado final (ex: "dd/mm/yyyy")
  return ordem;
}

// ############ Validação formulário ############

 const { handleSubmit, setValues } = useForm({
  validationSchema: toTypedSchema(
    object().shape({
      exjob_title: string().required(translate('this field is required', 'ucfirst'))
      .min(2,translate('this field must be at least 2 characters', 'ucfirst')).max(255,
      translate('this field must be at most 255 characters', 'ucfirst')
      ).ensure().trim().default(''),
      excompany_name: string().required(translate('this field is required', 'ucfirst'))
      .min(2,translate('this field must be at least 2 characters', 'ucfirst')).max(255,
      translate('this field must be at most 255 characters', 'ucfirst')
      ).ensure().trim().default(''),
      exdescription: string().required(translate('this field is required', 'ucfirst'))
      .min(50,translate('this field must be at least 50 characters', 'ucfirst')
      ).max(3000,
      translate('this field must be at most 3000 characters', 'ucfirst')
      ).ensure().trim().default(''),
      exstart_date: date().required(translate('this field is required', 'ucfirst')),
      exend_date: date()
    })
  )
});



// ############ Criação de Métodos/Funções ############ 

const addNewExperience = handleSubmit(async(values) => {   
  let formatedValues = {
    exjob_title: values.exjob_title,
    excompany_name: values.excompany_name,
    exstart_date: formatedDate(values.exstart_date),
    exend_date: values.exend_date != undefined ? formatedDate(values.exend_date) : '9999-12-31',
    exdescription: values.exdescription
  }

  if(values){  
    isLoading.value = !isLoading.value
    const response = await requestHandler.executeRequest("/api/curriculum/experiencie/create", formatedValues, 'post');
 
    isLoading.value = !isLoading.value

    if (!response.success) {  
      showToast(toast, translate('there was an error adding your experience', 'ucfirst'), 'error');
      return
    }
    
    showToast(toast, translate('added experience', 'ucfirst'));  
    emit('updateExperiencies', true) 
    emit('closeModal', false) 
  } 
})

 let updateExperience = handleSubmit(async(values) => {
    
  let formatedValues = {
    experience_id: props.experiencetoUpdate.id,
    exjob_title: values.exjob_title,
    excompany_name: values.excompany_name,
    exstart_date: formatedDate(values.exstart_date),
    exend_date: values.exend_date != undefined ? formatedDate(values.exend_date) : '9999-12-31',
    exdescription: values.exdescription
  }

   if (values) {  
     isLoading.value = !isLoading.value
     const response = await requestHandler.executeRequest("/api/curriculum/experiencie/update", formatedValues , 'put');
    
     isLoading.value = !isLoading.value
 
     if (!response.success) {
       showToast(toast, translate('there was an error updating your experience', 'ucfirst'), 'warn');
       return
     }
     showToast(toast, translate('your experience was updated', 'ucfirst'));
    emit('updateExperiencies', true) 
     emit('closeModal', false)

   }
 })

let deleteExperience = handleSubmit(async (values) => {

  const deleteBody = {
    item_type: "experience",
    item_id: props.experiencetoUpdate.id,
    curriculum_id: props.curriculumId
  };

  if (values) {
    isLoading.value = !isLoading.value;
    const response = await requestHandler.executeRequest("/api/curriculum/item/delete", deleteBody,"delete");

    isLoading.value = !isLoading.value;

    if (!response.success) {
      showToast(toast,translate("there was an error deleting your experience", "ucfirst"),"warn");
      return;
    }
    showToast(toast, translate("your experience was deleted", "ucfirst"));
    emit("closeModal", false);
    emit("updateExperiencies", true);
  }
});

function confirmDialogResponse(event) {
  
  showConfirmDialog.value = event.close;
  if (event.accepted) {
    deleteExperience()
  } 
}

function defineMaxDate(){
  let currentDate = new Date()
  let currentDay = currentDate.getDate() 
  let currentMonth = currentDate.getMonth() 
  let currentYear = currentDate.getFullYear() 

  maxDate.value.start_date.setMonth(currentMonth - 1 )
  maxDate.value.start_date.setFullYear(currentYear)
  maxDate.value.end_date.setDate(currentDay)
  maxDate.value.end_date.setMonth(currentMonth)
  maxDate.value.end_date.setFullYear(currentYear)
}

function formatedDate(date) { 
  let newFormat= `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  return newFormat
}

onMounted(() => {
    if (Object.keys(props.experiencetoUpdate).length > 0) {
      let end_date = props.experiencetoUpdate.end_date.slice(0,10)
      if (end_date == '9999-12-31') {
          exibirdateend.value = true
          end_date = undefined
          isPresent.value = true;
      }
      setValues({
        exjob_title: props.experiencetoUpdate.job_title,
        excompany_name: props.experiencetoUpdate.company_name,
        exdescription: props.experiencetoUpdate.description,
        exstart_date: props.experiencetoUpdate.start_date.slice(0,10),
        exend_date: props.experiencetoUpdate.end_date.slice(0,10),
      });
    }
})

onBeforeMount(() => defineMaxDate() )
</script>